import { render, staticRenderFns } from "./AccountPortalView.vue?vue&type=template&id=1c09c47a&scoped=true&"
import script from "./AccountPortalView.vue?vue&type=script&lang=js&"
export * from "./AccountPortalView.vue?vue&type=script&lang=js&"
import style0 from "./AccountPortalView.vue?vue&type=style&index=0&id=1c09c47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c09c47a",
  null
  
)

/* custom blocks */
import block0 from "./AccountPortalView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports